import { useMutation } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';

interface SendInvitationParams {
  clientId: string;
  email: string;
}

const sendInvitation = ({ clientId, email }: SendInvitationParams) => {
  return authFetch(urlWithParams('/Consumer/ConsumerEmailUpdate/SendInvitation', { clientId, email }), {
    method: 'POST',
  });
};

export const useSendInvitationMutation = () => {
  return useMutation(sendInvitation);
};
